import { notEmpty } from "@product/scmp-sdk";
import first from "lodash/first";
import { useEffect } from "react";
import { graphql, readInlineData } from "react-relay";

import { sendOnePlusXEvent } from "~/components/tracking/one-plus-x";
import type { hooksContentInterestArticle$key } from "~/queries/__generated__/hooksContentInterestArticle.graphql";

import { UrlSectionNameMap } from "./consts";

type Sentiment = Record<string, unknown> & {
  readability_school_level: string[];
  sentiment_category: string;
};

export const useTrackContentInterest = (article_: hooksContentInterestArticle$key | undefined) => {
  useEffect(() => {
    if (!notEmpty(article_)) return;

    const article = readInlineData(
      graphql`
        fragment hooksContentInterestArticle on Article @inline {
          entityId
          sentiment
          urlAlias
          types {
            value {
              name
            }
          }
          topics {
            name
          }
        }
      `,
      article_,
    );

    const [mainType] = first(article?.types ?? [])?.value ?? [];
    const contentType = `Article - ${mainType?.name ?? "Standard"}`;

    const sentiment = (article?.sentiment ?? {}) as Sentiment;
    const readabilitySchoolLevel = sentiment?.readability_school_level ?? [];
    const sentimentCategory = sentiment?.sentiment_category ?? "";
    const contentTopics =
      article?.topics?.map?.(topic => topic?.name ?? "").filter?.(name => notEmpty(name)) ?? [];

    const matchedPath =
      Object.keys(UrlSectionNameMap).find(path => article?.urlAlias?.startsWith?.(path)) ?? "";
    const sectionName = UrlSectionNameMap[matchedPath] ?? "";

    sendOnePlusXEvent({
      articleID: article.entityId,
      contentTopics: contentTopics?.join("|"),
      contentType,
      readability_school_level: readabilitySchoolLevel.join("|"),
      sentiment_category: sentimentCategory,
      siteVerticals: sectionName,
      type: "scmp-content-interests",
    });
  }, [article_]);
};
